import React, { useState } from 'react';
import QuestionLabel from './QuestionLabel';
import { getOptionsFromList } from '../../../lib/Questions';

const RadioQuestion = ({ label, value, setValue, settings }) => {
    const [name, setName] = useState('id' + Math.random());

    return (
        <div>
            <QuestionLabel label={label} settings={settings} />
            {settings?.options && (
                <div>
                    {getOptionsFromList(settings.options).map((opt, idx) => (
                        <label key={idx} className="flex items-center">
                            <input
                                type="radio"
                                name={name}
                                value={opt}
                                checked={value === opt}
                                onChange={e =>
                                    e.target.checked && setValue(opt)
                                }
                                className="mr-2"
                            />
                            {opt}
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RadioQuestion;
